<template>
  <div
    class="row pb-lgp mb-xl"
    :class="`bg-${backgroundColor}`">
    <HomepageSection
      title="Membership Perks">
      <div class="perk-wrapper">
        <div
          v-for="(perk, idx) in perks"
          :key="idx"
          class="perk d-flex flex-md-column align-items-center text-md-center mx-sm pt-lgp pb-md gap-lg gap-md-md">
          <HomepageImage
            :width="isTabletOrLarger ? 88 : 60"
            height="auto"
            class="mt-sm"
            :alt="`Decorative illustration of ${perk.title} ${perk.title2}`"
            :source="`how-it-works/membership-perks/${idx + 1}.svg`"
            source-type="image.svg"/>
          <div>
            <h3>
              {{ perk.title }}<span v-if="perk.title2"><br v-if="isTabletOrLarger"> {{ perk.title2 }}</span>
            </h3>
            <p>
              {{ perk.subtitle }}
            </p>
          </div>
        </div>
      </div>
    </HomepageSection>
  </div>
</template>

<script setup>
import HomepageImage from '@/homepage/components/HomepageImage.vue'
import HomepageSection from '@/homepage/components/HomepageSection.vue'
import useScreenSize from '@shared/composables/screenSize'

defineProps({
  backgroundColor: {
    type: String,
    default: 'origami'
  }
})

const { isTabletOrLarger } = useScreenSize()

const perks = [
  {
    title: 'Thousands of',
    title2: 'high-end styles',
    subtitle: '75K+ high-end items from hundreds of top designers'
  },
  {
    title: 'Buy what you love',
    title2: '(at a discount)',
    subtitle: 'Purchase your favorite items at members-only prices'
  },
  {
    title: 'Full-service',
    title2: 'styling',
    subtitle: 'Our stylists can curate a closet or case just for you'
  },
  {
    title: 'Free & fast shipping,',
    title2: 'both ways',
    subtitle: 'Reusable bag & prepaid shipping label are included for easy returns'
  },
  {
    title: 'Cleaning is',
    title2: 'on us',
    subtitle: 'Don\'t worry about laundry or dry cleaning, it\'s included!'
  },
  {
    title: 'Never be without',
    title2: 'clothes',
    subtitle: 'Keep your current case at home until your new items arrive'
  }
]
</script>

<style lang="scss" scoped>
.perk-wrapper {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  @include media-mobile {
    grid-template-columns: repeat(1, 1fr);
  }
}
.perk {
  @include media-tablet-or-larger {
    max-width: 350px;
    p {
      max-width: 300px;
    }
  }
}
</style>
